import * as React from 'react';

import {
  BooleanField,
  EditButton,
  RecordContextProvider,
  TextField,
  useListContext,
  useTranslate,
} from 'react-admin';
import { Box, Card, CardContent, CardHeader, Typography } from '@mui/material';

import { IDiscounts } from '../../types';

const MobileGrid = () => {
  const translate = useTranslate();
  const { data, isLoading } = useListContext<IDiscounts>();

  if (isLoading || data.length === 0) {
    return null;
  }

  return (
    <Box margin="0.5em">
      {data.map((record) => (
        <RecordContextProvider key={record.id} value={record}>
          <Card sx={{ margin: '0.5rem 0' }}>
            <CardHeader title={`${record.name}`} action={<EditButton />} />
            <CardContent sx={{ pt: 0 }}>
              <Typography variant="body2">
                {translate('resources.discounts.fields.discount')}
                :&nbsp;
                <TextField source="discount" />
              </Typography>
              <Typography variant="body2">
                {translate('resources.discounts.fields.allowPayments')}
                :&nbsp;
                <BooleanField source="allowPayments" />
              </Typography>
              <Typography variant="body2">
                {translate('resources.discounts.fields.allowBonus')}
                :&nbsp;
                <BooleanField source="allowBonus" />
              </Typography>
            </CardContent>
          </Card>
        </RecordContextProvider>
      ))}
    </Box>
  );
};

export default MobileGrid;
